import { EquipamentoOffGrid } from "../types";

export const calcularPotenciaEquipamentosOffGrid = (equipamentos: EquipamentoOffGrid[]): number => {
  return equipamentos?.filter(e => !e["@remove"])?.reduce((acc, curr) => acc + (curr.potencia * curr.quantidade), 0)
}